export default "__VITE_ASSET__92dee1ac__"